import { RootState } from '../../store';
import { createSelector } from '@reduxjs/toolkit';

const AuthorizationReducer = (state: RootState): RootState['AuthorizationReducer'] => state.AuthorizationReducer;
const selectAuthorizationState = createSelector([AuthorizationReducer], (state) => state);

export const selectAuthorizationStatus = createSelector([selectAuthorizationState], (state) => state.isAuth);